// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { Button } from 'ui'
import { Alert } from 'ui'
import ColorConstants from 'constants/ColorConstants'
import {Link} from 'react-router-dom'
import ProgressSteps from 'sign_up/ProgressSteps';


function DelveAccountBody(props) {
    const error = props.error ? props.error : {};

    return (
      <div>
        {props.currentStep &&
          <ProgressSteps currentStep={props.currentStep}/>
        }
         
        <div style={{ margin: "0 auto", fontFamily: "Libre Baskerville, serif"}} >
          <div style={{marginTop:40}}>
            <a href="https://www.delvetool.com" style={{textDecoration: "none"}} target="_blank">
              <h1 style={{textAlign:"center", color:ColorConstants.ACTIVE_BUTTON_BLUE, fontSize:"3.0em"}}><b>Delve</b></h1>
            </a>
          </div>

          {props.subHeader &&
            <p style={{textAlign:"center", marginTop:30}}>{props.subHeader}</p>
          }
          <div style={{marginTop:10, marginBottom: 10}}>
            <div style={{width: "500px", margin: "0 auto"}}>
              <div style={{margin:30}}>
                {error.error &&
                  <Alert variant="warning" style={{textAlign:"center"}}>
                      {error.message}
                  </Alert>
                }
                {props.success && props.success.message &&
                  <Alert variant="success" style={{textAlign:"center"}}>
                    <p>
                      {props.success.message}
                    </p>
                  </Alert>
                }
              </div>
            </div>
          </div>

          <div style={{marginTop:30}}>
            {props.children}
          </div>

          <div style={{
            textAlign:"center",
            position:'absolute',
            width:"500px",
            bottom:"10px",
            right:"25%",
            left:"50%",
            marginLeft:"-250px"
          }}>
            {props.login &&
              <p>Have an account? <Link to={`/sign_in`}>Login</Link></p>
            }
            {props.remember &&
              <p>Remember your password? <Link to={`/sign_in`}>Login</Link></p>
            }
            {props.reset && !props.signUp &&
              <div style={{textAlign: "left", width:"100%", marginBottom: "10px"}}>
                <div style={{width: "80%", marginLeft:'50px', marginTop:0}}>
                  <div style={{display: 'flex', textAlign: 'center', marginTop: 0}}>
                    <div style={{flex: 5, textAlign: 'right'}}>
                      <Link to={`/sign_up`}>Create an Account</Link>
                    </div>
                    <div style={{flex: 2, textAlign: 'center'}}> | </div>
                    <div style={{flex: 5, textAlign: 'left'}}>
                      <Link to={`/forgot`}>Can't log in?</Link>
                    </div>
                  </div>
                </div>
              </div>
            }
            {props.reset && props.signUp &&
                <p>
                  <Link style={{margin:30}} to={`/forgot`}>Forgot password?</Link>
                  <Link style={{margin:30}} to={`/sign_up`}>Sign Up for Delve</Link>
                </p>
            }
            {props.onSignOut && 
              <Button variant="link" onClick={props.onSignOut}>
                              Log Out
              </Button>
            }
          </div>
        </div>
      </div>

    );
}

export default DelveAccountBody;
